import * as React from 'react';
import { StyledSvg } from './LoaderIcon.styles';

export const LoaderIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
    <StyledSvg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            opacity="0.1"
            d="M40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24ZM11.9994 24C11.9994 30.6277 17.3723 36.0006 24 36.0006C30.6277 36.0006 36.0006 30.6277 36.0006 24C36.0006 17.3723 30.6277 11.9994 24 11.9994C17.3723 11.9994 11.9994 17.3723 11.9994 24Z"
            fill="currentColor"
        />
        <path
            d="M37.9997 24C39.1044 24 40.0129 23.101 39.8751 22.0049C39.6972 20.5893 39.3304 19.2008 38.7821 17.8771C37.978 15.9359 36.7994 14.172 35.3137 12.6863C33.828 11.2006 32.0641 10.022 30.1229 9.21793C28.7992 8.66963 27.4107 8.30278 25.9951 8.12487C24.899 7.98712 24 8.89555 24 10.0003C24 11.105 24.9016 11.9836 25.991 12.1669C26.8813 12.3167 27.754 12.5668 28.592 12.9139C30.0478 13.517 31.3706 14.4008 32.4849 15.5151C33.5992 16.6294 34.483 17.9522 35.0861 19.408C35.4332 20.246 35.6833 21.1187 35.8331 22.009C36.0164 23.0984 36.895 24 37.9997 24Z"
            fill="currentcolor"
        />
    </StyledSvg>
);
